export interface Material {
    id: string;
    artikelnummer: string;
    namn: string;
    leverantor: string;
    streckkod1: string;
    streckkod2: string;
}

export const convertMaterialData = (material: Material) => {
    if (!material) {
        return null;
    }

    return {
        id: material.id,
        value: material.id,
        label: `${material.namn} (${material.artikelnummer})`,
    };
};
